export default __webpack_public_path__ + "static/media/Frame17.0336463c.png";